export const catGrupoPaqueteProveedor = Object.freeze({
    NoAplica: 0,
    ID_PROVEEDOR_GRAN_TOUR: 26,
})